import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ClerkProvider } from '@clerk/clerk-react';
import dayjs from 'dayjs';
import 'dayjs/locale/el'; // Greek locale
import './timeInputStyles.css';
import './capacitorMobile.css';
import theme from './theme'; // Shopify Polaris theme
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';

// Set Greek locale for dayjs
dayjs.locale('el');

// Initialize Capacitor plugins when running as native app
if (Capacitor.isNativePlatform()) {
  StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  StatusBar.setBackgroundColor({ color: '#008060' }).catch(() => {});

  Keyboard.setAccessoryBarVisible({ isVisible: true }).catch(() => {});

  // Hide splash screen after app loads
  SplashScreen.hide().catch(() => {});
}

// Clerk Publishable Key
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.warn('Missing Clerk Publishable Key - Authentication disabled');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="el">
          <App />
        </LocalizationProvider>
      </ThemeProvider>
    </ClerkProvider>
  </React.StrictMode>
);
